import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

import { AppConfig, CMPS_APP_CONFIG } from '../../../app.config';
import { mapRetrieve } from '../../../common/rest.operators';
import { CoachingDateToday } from '../models/coaching.global.model';

@Injectable()
export class CoachingService {
    constructor(
        private readonly _http: HttpClient,
        private readonly _router: Router,
        @Inject(CMPS_APP_CONFIG) private readonly _appConfig: AppConfig,
    ) {}

    retrieveHistory(
        which: string = 'observationhistory',
        performerId: number,
        periodTypeId: string,
        numRecords: number,
    ): Observable<any> {
        let params = new HttpParams().set(
            'performerUserId',
            performerId.toString(),
        );
        if (periodTypeId != null) {
            params = params.set('periodTypeId', periodTypeId);
        }
        if (numRecords != null) {
            params = params.set('numRecords', numRecords.toString());
        }

        return this._http
            .get(
                `${this._appConfig.API_ENDPOINTS.COACHING}/coaching/${which}`,
                { params },
            )
            .pipe(mapRetrieve());
    }

    retrieveObservationHistory(
        performerId,
        periodTypeId,
        numRecords,
    ): Observable<any> {
        return this.retrieveHistory(
            'observationhistory',
            performerId,
            periodTypeId,
            numRecords,
        );
    }

    retrieveCommitmentHistory(
        performerId: number,
        periodTypeId: string,
        numRecords: number,
    ): Observable<any> {
        return this.retrieveHistory(
            'commitmenthistory',
            performerId,
            periodTypeId,
            numRecords,
        );
    }

    retrieveGoalHistory(
        performerId: number,
        periodTypeId: string,
        numRecords: number,
    ): Observable<any> {
        return this.retrieveHistory(
            'goalhistory',
            performerId,
            periodTypeId,
            numRecords,
        );
    }

    retrieveCommitmentDetails(
        commitmentId: number,
        userId: number,
        periodTypeId: string,
        languageId?: number,
    ): Observable<any> {
        const params = new HttpParams()
            .set('performerUserId', userId.toString())
            .set('coachingEventId', commitmentId.toString())
            .set('languageId', languageId.toString())
            .set('periodTypeId', periodTypeId)
            .set('currentDate', CoachingDateToday.toJSON());

        return this._http
            .get(
                `${this._appConfig.API_ENDPOINTS.COACHING}/coaching/getCommitmentDetails`,
                { params },
            )
            .pipe(mapRetrieve());
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    openIFrame(eventtype: string, stateOrId: string | number, userId: number) {
        let method;

        if (stateOrId === 'new') {
            method = `coaching/coaching.aspx#/${eventtype}/New/${userId}`;
            if (eventtype === 'Commitment') {
                method = `coaching/coaching.aspx#/New${eventtype}/${userId}`;
            }
        } else {
            // we're opening an existing eventSubType (commitment/observation)
            method = `coaching/coaching.aspx#/${eventtype}/${stateOrId}`;
        }

        const baseHref = `${this._appConfig.WEB_FORMS_BASE_URL}`;
        const url = `${baseHref}${this._router
            .createUrlTree([method])
            .toString()
            .replace(/\/\//g, '/')}`;
        // might be unsafe
        window.open(
            decodeURIComponent(url),
            'mywindow',
            'menubar=1,resizable=1,width=1400,height=700',
        );
    }
}
